'use client'

export default function MetadataScripts({ script }: { script: string }) {
    return (
        <>
            <script
                type="application/ld+json"
                dangerouslySetInnerHTML={{ __html: script }}
            ></script>
        </>
    )
}
